export const HERD_MANAGEMENT_PAGINATION_DATA = 'HERD_MANAGEMENT_PAGINATION_DATA'
export const NEXT_PAGE = 'NEXT_PAGE'
export const RESET_PAGE = 'RESET_PAGE'
